import {
    Box,
    Button,
    Container,
    Flex,
    HStack,
    Icon,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    VStack,
    chakra,
    useColorModeValue,
} from '@chakra-ui/react'
// Here we have used react-icons package for the icons
import { useEffect, useState } from 'react'
import { BiCheck } from 'react-icons/bi'
import { FaStar } from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom'
import { maintenancePlansList, plansList } from './pricingData'

const colorOfStars = (stars: number) => {
    switch (stars) {
        case 1:
            return 'BlackAlpha.50'
        case 2:
            return 'gray.400'
        case 3:
            return 'yellow.300'
        case 4:
            return 'gray.100'
        case 5:
            return 'pink.300'
    }
}

const ServicesPage = () => {
    // const tabProps = useTab({})
    // console.log('selected Tab', tabProps['aria-selected'])
    const { hash } = useLocation()
    console.log(hash)
    const tabs: { [key: string]: number } = { '#website': 0, '#maintenance': 1 }

    const [defaultIndex, setDefaultIndex] = useState(0)
    useEffect(() => {
        setDefaultIndex(tabs[hash])
    }, [tabs, hash])

    return (
        <Container maxW="8xl" minH={'100vh'} mt={12} py="4" centerContent>
            <chakra.h2
                fontSize="4xl"
                fontWeight="bold"
                textAlign="center"
                mb={12}
            >
                Simple and affordable pricing
            </chakra.h2>
            <Tabs
                defaultIndex={defaultIndex}
                isFitted
                variant="soft-rounded"
                color="#33186B"
            >
                <TabList>
                    <Tab>Website Development</Tab>
                    <Tab>Website Maintenance</Tab>
                    {/* <Tab>Graphic Design</Tab>
                    <Tab>Business Card Design</Tab>
                    <Tab>Logo Design</Tab> */}
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <Flex
                            wrap={'wrap'}
                            mt={4}
                            justifyContent={'center'}
                            columnGap={4}
                        >
                            {plansList.map((plan, index) => (
                                <PricingCard
                                    width={'3xs'}
                                    key={index}
                                    {...plan}
                                />
                            ))}
                        </Flex>
                    </TabPanel>
                    <TabPanel>
                        <Flex
                            wrap={'wrap'}
                            mt={4}
                            justifyContent={'center'}
                            columnGap={4}
                        >
                            {maintenancePlansList.map((plan, index) => (
                                <PricingCard
                                    width={'sm'}
                                    key={index}
                                    {...plan}
                                />
                            ))}
                        </Flex>
                    </TabPanel>
                    {/* <TabPanel>
                        <p>three!</p>
                    </TabPanel> */}
                </TabPanels>
            </Tabs>
        </Container>
    )
}

interface PricingCardProps {
    title: string
    price: number
    features: string[]
    stars: number
    width: string
}

const PricingCard = ({
    title,
    price,
    stars,
    features,
    width,
}: PricingCardProps) => {
    return (
        <Flex
            flexDirection={'column'}
            w={{ base: 'xs', lg: '3xs', xl: width }}
            rounded="md"
            bg={useColorModeValue('white', 'gray.800')}
            boxShadow="base"
            border={'2px solid #EDF2F7'}
            my={3}
            p={6}
        >
            <Box textAlign="center">
                {[...Array(stars)].map((p, i) => (
                    <Icon
                        key={i}
                        as={FaStar}
                        h={7}
                        w={7}
                        color={colorOfStars(stars)}
                        textShadow={`0 0 3px #000`}
                    />
                ))}
                <chakra.h2 fontSize="2xl" fontWeight="bold">
                    {title}
                </chakra.h2>
                <Text fontSize="4xl" fontWeight="bold">
                    <Text
                        as="sup"
                        fontSize="3xl"
                        fontWeight="normal"
                        top="-0.1em"
                    >
                        $
                    </Text>
                    {price}
                </Text>
            </Box>
            <Flex
                flex={1}
                flexDirection={'column'}
                justifyContent={'space-between'}
                justify={'center'}
            >
                <VStack spacing={2} my={6}>
                    {features.map((feature, index) => (
                        <HStack
                            key={index}
                            spacing={3}
                            borderBottom={'1px solid gray'}
                            pb={1}
                            px={1}
                        >
                            <Icon as={BiCheck} h={4} w={4} color="green.500" />
                            <Text fontSize="sm" color="gray.500">
                                {feature}
                            </Text>
                        </HStack>
                    ))}
                </VStack>

                <Link to={'/contact'}>
                    <Button
                        background="#7360DF"
                        color={'white'}
                        variant="solid"
                        size="md"
                        rounded="md"
                        w="100%"
                    >
                        Get Started
                    </Button>
                </Link>
            </Flex>
        </Flex>
    )
}

export default ServicesPage
